exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tagInput .ivu-input{border:0}.tagInput .ivu-input:focus{-webkit-box-shadow:0 0 0;box-shadow:0 0 0}", ""]);

// exports
